import React, { useEffect, useState, useRef } from "react";
import ContactPopup from "../ContactPopup";
// import "./ServicePage.css";
import "../ImportExport/ServicePages.css";

const ISOCertification = () => {


  const [openPopup, setOpenPopup] = useState(false);

  const contactRef = useRef(null);

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="service-page">

      {/* HERO */}
      <section className="service-hero">
        <h1>ISO Certification / Registration Service</h1>
        <p>Get ISO Certified & Build Global Trust</p>
       <button className="hero-btn" onClick={scrollToContact} >
          Get Started Today
        </button>
      </section>

      {/* OVERVIEW */}
      <section className="service-section">
        <h2>Overview</h2>
        <p>
          ISO Certification is an internationally recognized standard that
          demonstrates your business follows high-quality processes, efficient
          management systems, and customer-focused operations.
        </p>
        <p>
          It helps businesses build trust, improve credibility, and expand
          opportunities in both domestic and global markets.
        </p>
        <p>
          We provide quick and hassle-free ISO registration and certification
          support for all types of businesses.
        </p>
      </section>

      {/* TYPES (CARDS) */}
      <section className="service-section">
        <h2>Types of ISO Certifications</h2>

        <div className="card">
          <div className="service-card">ISO 9001 – Quality Management</div>
          <div className="service-card">ISO 14001 – Environmental</div>
          <div className="service-card">ISO 45001 – Health & Safety</div>
          <div className="service-card">ISO 27001 – Information Security</div>
          <div className="service-card">ISO 22000 – Food Safety</div>
          <div className="service-card">ISO 13485 – Medical Devices</div>
        </div>
      </section>

      {/* WHO NEEDS */}
      <section className="service-section">
        <h2>Who Needs ISO Certification?</h2>

        <div className="card-grid">
          <div className="service-card">Startups</div>
          <div className="service-card">SMEs</div>
          <div className="service-card">Manufacturing Companies</div>
          <div className="service-card">Service Providers</div>
          <div className="service-card">Exporters & Traders</div>
          <div className="service-card">IT & Software Companies</div>
        </div>
      </section>

      {/* BENEFITS */}
      <section className="service-section">
        <h2>Benefits of ISO Certification</h2>

        <div className="card-grid">
          <div className="service-card">✔ Improves credibility & trust</div>
          <div className="service-card">✔ Enhances customer satisfaction</div>
          <div className="service-card">✔ Helps in tenders</div>
          <div className="service-card">✔ Increases efficiency</div>
          <div className="service-card">✔ Boosts global opportunities</div>
          <div className="service-card">✔ Competitive advantage</div>
        </div>
      </section>

      {/* SERVICES */}
      <section className="service-section">
        <h2>Our ISO Registration Services Include</h2>

        <div className="card-grid">
          <div className="service-card">Business consultation</div>
          <div className="service-card">Documentation support</div>
          <div className="service-card">Application filing</div>
          <div className="service-card">Audit coordination</div>
          <div className="service-card">Certificate assistance</div>
          <div className="service-card">Post-certification support</div>
        </div>
      </section>

      {/* DOCUMENTS */}
      <section className="service-section">
        <h2>Documents Required</h2>
        <ul>
          <li>PAN Card of business</li>
          <li>Aadhaar Card of owner/directors</li>
          <li>Business registration proof</li>
          <li>Address proof of business</li>
          <li>Business activity details</li>
          <li>Contact & email information</li>
        </ul>
      </section>

      {/* PROCESS */}
      <section className="service-section">
        <h2>ISO Certification Process</h2>
        <ul>
          <li>Consultation & requirement analysis</li>
          <li>Selection of ISO standard</li>
          <li>Documentation preparation</li>
          <li>Application submission</li>
          <li>Audit (if required)</li>
          <li>Certification issuance</li>
        </ul>
      </section>

      {/* WHY CHOOSE US */}
      <section className="service-section">
        <h2>Why Choose Us?</h2>

        <div className="card-grid">
          <div className="service-card">✔ Fast process</div>
          <div className="service-card">✔ Expert guidance</div>
          <div className="service-card">✔ Affordable pricing</div>
          <div className="service-card">✔ End-to-end support</div>
          <div className="service-card">✔ Trusted service</div>
        </div>
      </section>

      {/* CTA */}
      {/* <section className="service-cta">
        <h2>Build trust and grow globally with ISO Certification</h2>
        <p>Get certified quickly and enhance your brand value.</p>
        <button>Contact Us</button>
      </section> */}


      
            <div className="cta" ref={contactRef}>
              <h2>Build trust and grow globally with ISO Certification</h2>
              <p>Get certified quickly and enhance your brand value.</p>
      
              <div className="cta-buttons">
                <button onClick={() => setOpenPopup(true)}>Contact Us Now</button>
                <ContactPopup
                  isOpen={openPopup}
                  onClose={() => setOpenPopup(false)}
                />
      
                <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
              </div>
            </div>

    </div>
  );
};

export default ISOCertification;